<template>
    <div>
        <div class="d-flex mb-5 justify-space-between">
            <v-spacer></v-spacer>
            <v-btn color="primary text--white" @click="addNewPriceDialog = true">
                <v-icon left class="mr-4"> mdi-plus </v-icon>
                {{ $t("addNewPriceLabel") }}
            </v-btn>
        </div>
        <v-data-table :headers="pricing.headers" :footer-props="pricing.footerProps" :items="prices" :items-per-page="10">
            <template #item.name="{item}" >
                <span v-if="
                editableName.id ?
                editableName.id !== item.id : true" @dblclick="editableName = item">{{item.name}}</span>
                <div v-else-if="editableName.id === item.id">
                    <v-text-field :value="item.name" v-model="item.name" style="width:50%" dense class="mt-3">
                        <template v-slot:append-outer>
                            <v-btn icon small fab dark color="green darken-1" class="mt-n2" @click="updatePrice(item)">
                                <v-icon>mdi-checkbox-marked-circle</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </div>
            </template>
            <template #item.value="{item}" >
                <span v-if="
                editableValue.id ?
                editableValue.id !== item.id : true" @dblclick="editableValue = item">{{ parseToGermanFloat(item.value)}} %</span>
                <div v-else-if="editableValue.id === item.id">
                    <v-text-field :value="item.value" v-model="item.value" style="width:50%" dense class="mt-3">
                        <template v-slot:append-outer>
                            <v-btn icon small fab dark color="green darken-1" class="mt-n2" @click="updatePrice(item)">
                                <v-icon>mdi-checkbox-marked-circle</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </div>
            </template>
            <template #item.actions="{ item }">
                <v-btn
                        class="ma-2"
                        :color="item.isDefault ? 'primary' : 'green'"
                        dark
                        @click="setDefaultPrice(item)"
                >
                    <v-icon
                            dark
                            left
                    >
                        {{ item.isDefault ? 'mdi-check-all' : 'mdi-checkbox-marked-circle' }}
                    </v-icon>{{ item.isDefault ? $t('defaultPriceLabel') : $t('setAsDefaultLabel') }}
                </v-btn>
                <v-btn icon x-small outlined fab dark color="red darken-1" @click="openDeletePriceDialog(item)">
                    <v-icon>mdi-trash-can</v-icon>
                </v-btn>
            </template>
            <template v-slot:no-data>
                {{$t('noDataAvailable')}}
            </template>
            <template v-slot:no-results>
                {{$t('noDataAvailable')}}
            </template>
        </v-data-table>
        <v-dialog v-model="addNewPriceDialog" max-width="500px">
            <v-card class="pa-10">
                <v-card-title class="justify-center">{{
                    $t("addPriceTitleLabel")
                    }}</v-card-title>

                <div>
                    <v-text-field v-model="nameParam" outlined :label="$t('nameFormLabel')"></v-text-field>
                    <v-text-field v-model="valueParam" outlined :label="$t('valueFormLabel')" hint="0.00">
                        <template v-slot:append>
                            <v-icon>mdi-percent</v-icon>
                        </template>
                    </v-text-field>
                </div>

                <v-card-actions>
                    <v-row>
                        <v-col cols="6">
                            <v-btn @click="createNewPrice()" width="100%" small color="green white--text">{{ $t('confirmAddPriceLabel') }}</v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn width="100%" small color="primary" @click="addNewPriceDialog = false">
                                {{ $t("cancelLabel") }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                :close-delay="3000"
                v-model="snackbar.show"
                max-width="360"
                overlay-opacity="0.3"
        >
            <v-card>
                <div class="pa-4 pb-0">
                    <div class="subtitle-1 text-center" v-text="snackbar.message"></div>
                </div>
                <v-card-actions>
                    <v-btn
                            small
                            class="mx-auto"
                            color="primary"
                            @click="snackbar.show = false"
                    >
                        {{$t('closeLabel')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deletePriceDialog" max-width="500px">
            <v-card class="pa-10">
                <v-card-title class="justify-center">{{
                    $t("deletePriceTitle")
                    }}</v-card-title>
                <p class="text-center">{{ $t("deletePriceDescription") }}</p>

                <v-card-actions>
                    <v-row>
                        <v-col cols="6">
                            <v-btn @click="deletePrice(item.id)" width="100%" small color="red white--text">{{ $t('deletePriceConfirm') }}</v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn width="100%" small color="primary" @click="deletePriceDialog = false">
                                {{ $t("cancelLabel") }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {parseFloatFromGermanFloat, parseToGermanFloat} from "@/services/ParserService";

    export default {
        props: ['prices'],
        name: "PricingTable",
        data() {
            return {
                parseToGermanFloat: parseToGermanFloat,
                editableName: '',
                editableValue: '',
                addNewPriceDialog: false,
                deletePriceDialog: false,
                nameParam: '',
                valueParam: '',
                snackbar: {
                    show: false,
                    message: "",
                },
                item: {},
                pricing: {
                    headers: [
                        {
                            text: this.$t('pricingIdLabel'),
                            value: "id",
                            width: "20%"
                        },
                        {
                            text: this.$t('pricingNameLabel'),
                            value: "name",
                            width: "20%"
                        },
                        {
                            text: this.$t('pricingValueLabel'),
                            value: "value",
                            width: "20%"
                        },
                        {
                            text: "",
                            sortable: false,
                            value: "actions",
                            align: "end",
                        },
                    ],
                  footerProps:{
                    'items-per-page-options' : [1, 5, 10, 15, 20, -1],
                    'items-per-page-all-text': this.$t('allLabel'),
                    'items-per-page-text': this.$t('rowsPerPageLabel')
                  }
                },
            }
        },
        methods: {
            updatePrice(item) {
                let params = {
                    "Id": item.id,
                    "Name": item.name,
                    "Value": parseFloat(parseFloatFromGermanFloat(item.value))
                }
                this.axios.put("api/extra-charge", params)
                .then(() => {
                    this.editableName = '';
                    this.editableValue = '';
                })
                .catch((error) => {
                  console.log(error)
                })
            },
            createNewPrice() {
                let params = {
                    "Name": this.nameParam,
                    "Value": parseFloat(this.valueParam),
                }
                this.axios.post("api/extra-charge", params)
                    .then((response) => {
                        this.prices.push({
                            id: response.data.id,
                            name: this.nameParam,
                            value: this.valueParam,
                            isDefault: response.data.isDefault
                        })

                        this.snackbar.message = this.$t("priceAddedLabel")
                        this.snackbar.show = true;

                        this.addNewPriceDialog = false;
                        this.nameParam = '';
                        this.valueParam='';

                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            setDefaultPrice(item) {
                let params = {
                    "id": item.id,
                    "isDefault": !item.isDefault
                }
              this.axios.put("api/extra-charge/set-default", params)
                .then(() => {
                    let allPrices = this.prices.filter(x => x.isDefault === true && x.id !== item.id);
                    for(let i = 0; i< allPrices.length; i ++) {
                        allPrices[i].isDefault = false;
                    }
                    let updateLast = this.prices.find(x => x.id === item.id);
                    updateLast.isDefault = !item.isDefault;
                })
                .catch((error) => {
                    console.log(error)
                })
            },
            openDeletePriceDialog(item) {
                this.item = item;
                this.deletePriceDialog = true;
            },
            deletePrice(id) {
                this.axios.delete("api/extra-charge", {
                    params: {
                        id: id,
                    },
                })
                .then(() => {
                    let index = this.prices.findIndex(x => x.id === id);
                    this.prices.splice(index, 1);

                    this.deletePriceDialog = false;

                    this.snackbar.message = this.$t("priceDeletedLabel")
                    this.snackbar.show = true;
                })
                .catch(() => {
                    this.snackbar.message = this.$t("priceErrorLabel")
                    this.snackbar.show = true;
                })
            }
        },
        mounted() {
            const css = '.v-data-footer__pagination{\n' +
                '   display: block;\n' +
                '}\n' +
                '.v-data-footer__icons-before{\n' +
                '    display: block;\n' +
                '}\n' +
                '.v-data-footer__icons-after{\n' +
                '    display: block;\n' +
                '}'
            this.styleTag = document.createElement('style');
            this.styleTag.appendChild(document.createTextNode(css));
            document.head.appendChild(this.styleTag);
        },
        destroyed() {
            this.styleTag.remove();
        },
    }
</script>

<style scoped>

</style>